import React from "react";
import styled from "@emotion/styled";
import mq from "../utils/mediaQueries";
import useWindowSize from "../hooks/useWindowSize";
import { breakpoints } from "../hooks/useBreakpoint";

const Wrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${mq("md")} {
    flex-direction: row;
  }
`;

const Kit = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem 1rem 0 1rem;
  justify-content: center;
  text-align: center;

  ${mq("lg")} {
    flex: 1.25;
  }

  ${mq("sm")} {
    justify-content: flex-start;
    text-align: left;
  }
`;

const OtherGear = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 1rem 1rem 0 1rem;

  justify-content: center;
  text-align: center;

  ${mq("lg")} {
    flex: 1;
  }

  ${mq("sm")} {
    justify-content: flex-start;
    text-align: left;
  }
`;

const HolosAndItemSlotsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;

  :first-of-type {
    padding-bottom: 1rem;
  }

  ${mq("sm")} {
    padding: 1rem 0 0 0;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const HolosAndItemSlots = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  & p {
    font-size: 1.75rem;
    padding-bottom: 1rem;

    ${mq("md")} {
      padding-bottom: 0;
    }
  }
`;

const Inventory = ({ character }) => {
  const { width } = useWindowSize();

  return (
    <Wrapper>
      <Kit>
        <h1>{"/// STARTING KIT ///"}</h1>
        <p>
          {`${character.startingKit.name.toUpperCase()} - ${
            character.startingKit.description
          }.`}
        </p>
      </Kit>
      <OtherGear>
        <h1>
          {width <= breakpoints.xs
            ? "/// TRINKET ///"
            : "/// PERSONAL TRINKET ///"}
        </h1>
        <p>{character.personalTrinket}</p>
        <HolosAndItemSlotsWrapper>
          <HolosAndItemSlots>
            <h1>$$$ HOLOS $$$</h1>
            <p>{character.holos}</p>
          </HolosAndItemSlots>
          <HolosAndItemSlots>
            <h1>... ITEM SLOTS ...</h1>
            <p>{character.itemSlots}</p>
          </HolosAndItemSlots>
        </HolosAndItemSlotsWrapper>
      </OtherGear>
    </Wrapper>
  );
};

export default Inventory;
